// `/recuperar` — pedir un enlace para volver a entrar.
//
// ⚠️ LA PANTALLA MUESTRA SIEMPRE EL MISMO MENSAJE, exista o no la cuenta. No es
// pereza de diseño: si dijera «ese correo no está registrado», cualquiera podría
// usar esta pantalla para averiguar quién tiene cuenta — y la lista de cuentas
// es la del proyecto ENTERO, compartida por seis productos. El servidor también
// responde igual siempre; esto es la otra mitad de la misma decisión.
import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Aviso, Boton } from "@victorix/chat-ai-ui";
import { Campo, MarcoAuth } from "./_marco.tsx";

const FUNCIONES = `${import.meta.env.VITE_SUPABASE_URL ?? ""}/functions/v1`;

export default function RecuperarClave() {
  const [params] = useSearchParams();
  const [correo, setCorreo] = useState(params.get("correo") ?? "");
  const [enviado, setEnviado] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function pedir(e: React.FormEvent) {
    e.preventDefault();
    setEnviando(true); setError(null);
    try {
      await fetch(`${FUNCIONES}/chatai-recuperar-clave`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: correo.trim().toLowerCase() }),
      });
      setEnviado(true);          // pase lo que pase del otro lado
    } catch {
      setError("No se pudo conectar. Revisa tu internet.");
    }
    setEnviando(false);
  }

  if (enviado) {
    return (
      <MarcoAuth titulo="Revisa tu correo">
        <div className="text-[14px] text-tinta-2 leading-relaxed space-y-3">
          <p>
            Si <b className="text-tinta">{correo}</b> tiene acceso a Victorix Chat AI, te
            va a llegar un enlace para crear una contraseña nueva.
          </p>
          <p>Vence en 1 hora. Si no lo ves, mira en spam.</p>
        </div>
        <Link to="/" className="block mt-6">
          <Boton tono="neutro" className="w-full">Volver a entrar</Boton>
        </Link>
      </MarcoAuth>
    );
  }

  return (
    <MarcoAuth
      titulo="Recuperar contraseña"
      bajada="Te mandamos un enlace al correo con el que entras."
    >
      <form onSubmit={pedir}>
        <Campo
          id="correo" etiqueta="Correo" type="email" autoComplete="email" required
          value={correo} onChange={(e) => setCorreo(e.target.value)}
        />
        {error && <div className="mt-4"><Aviso tono="peligro">{error}</Aviso></div>}
        <Boton type="submit" tono="marca" className="mt-6 w-full" disabled={enviando || !correo}>
          {enviando ? "Enviando…" : "Enviarme el enlace"}
        </Boton>
        <p className="mt-4 text-center">
          <Link to="/" className="text-[13px] text-tinta-2 hover:text-marca transition">
            Volver
          </Link>
        </p>
      </form>
    </MarcoAuth>
  );
}
